import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { PolicyService } from '@campfire-nx/api';
import { UserDataService } from '@open-portal-app/core/services/user-data.service';

import {
  AUTO_RENEWAL_FLOW_PAGE_ONE,
  AUTO_RENEWAL_FLOW_SUCCESS_PAGE,
  AUTO_RENEWAL_ERROR_PAGE,
  AUTO_RENEW_FINAL_PAGES,
} from '../constants/auto-renewal-flow-v001';

import {RENEWAL_ACTIVE_STATES, RENEWAL_INACTIVE_STATES,RENEWAL_ALLOWED_UPDATE_TO} from '../constants/auto-renewal.states'

@Injectable(
  {providedIn: 'root'}
)
export class AutoRenewalManagerService {
  steps!: any;
  currentStepIndex = 0;
  eventCategory!: string;
  private policy!: any;
  private activeStates = RENEWAL_ACTIVE_STATES;
  private inactiveStates = RENEWAL_INACTIVE_STATES;
  private updateToFlag: typeof RENEWAL_ALLOWED_UPDATE_TO[number] = null;
  policySlug!: string;

  constructor(
    private router: Router,
    private userDataService: UserDataService,
    private policyService: PolicyService
  ) { }

  getFirstStep(policy: any) {
    this.currentStepIndex = 0;
    this.policy = policy;
    this.policySlug = this.policy.uuid || this.policy.slug;
    this.setAutoRenewalFlow();

    return this.getFlowPage(0);
  }

  getFlowPage(index: number): any {
    if (!this.steps || this.steps[index] === undefined) {
      return AUTO_RENEWAL_ERROR_PAGE;
    }

    return this.steps[index];
  }

  setAutoRenewalFlow() {
    const renewalFlag: string = this.policy.renewal_flag;
    this.steps = [AUTO_RENEWAL_FLOW_PAGE_ONE, AUTO_RENEWAL_FLOW_SUCCESS_PAGE];

    this.steps.forEach((step: any) => {
      step.data.renewal_flag = this.policy.renewal_flag;
    });

    if (this.activeStates.includes(renewalFlag)) {
      // DisableFlow
      this.eventCategory = 'RenewalFlagDisableFlow';
      this.updateToFlag = 'CD';
    } else if (this.inactiveStates.includes(renewalFlag)) {
      // EnableFlow
      this.eventCategory = 'RenewalFlagEnableFlow';
      this.updateToFlag = 'CE';
    } else {
      // Unsupported
      this.eventCategory = 'RenewalFlagUnsupportedFlow';
      this.steps = [AUTO_RENEWAL_ERROR_PAGE];
    }
  }

  next(payload: any) {
    const isConfirmed: boolean = payload.confirmationOn || payload.confirmationOff || false;

    return new Promise((resolve) => {
      if (this.currentStepIndex === this.steps.length - 2) {
        // We are in the submission page
        if (this.updateToFlag && isConfirmed) {
          this.policyService.updateRenewalFlag(this.policySlug, this.updateToFlag)
            .then((response: any) => {
              if (response.status === 200) {
                this.userDataService.getLatestUserData();
                this.currentStepIndex += 1;
                resolve(this.getFlowPage(this.currentStepIndex));
              } else {
                resolve(AUTO_RENEWAL_ERROR_PAGE);
              }
            }).catch((error: any) => {
              resolve(AUTO_RENEWAL_ERROR_PAGE);
            });
        } else {
          resolve(true);
          this.goToDashboard();
        }
      } else if (AUTO_RENEW_FINAL_PAGES.includes(this.steps[this.currentStepIndex].flow_slug)) {
        // this is the final page
        resolve(true);
        this.goToDashboard();
      } else {
        // otherwise go to the next page
        this.currentStepIndex += 1;
        resolve(this.getFlowPage(this.currentStepIndex));
      }
    });
  }

  goToDashboard() {
    this.currentStepIndex = 0;
    this.router.navigate(['/dashboard']);
  }

  back() {
    return new Promise((resolve) => {
      if (this.currentStepIndex === 0) {
        this.router.navigate([`/policy/${this.policy.product.base_product.class}/${this.policySlug}`]);
      } else {
        this.currentStepIndex -= 1;
        resolve(this.getFlowPage(this.currentStepIndex));
      }
    });
  }
}
